import { Star, StarOutline } from "@mui/icons-material";
import { Box, SvgIconProps, SxProps, Theme } from "@mui/material";
import { FormFieldValueGroupUI } from "Backend";
import { FormFieldContext } from "contexts/FormFieldContext";
import { FieldValueGroupSelectionStatus } from "generated/graphql";
import { useContext } from "react";
import { useAppSelector } from "redux/hooks";
import { selectForm } from "redux/slices/form.slice";
import { goldStar } from "theme/palette";

export function ValueGroupStar({
  group,
  sx,
  readonly,
}: {
  group: FormFieldValueGroupUI;
  sx?: SxProps<Theme>;
  readonly?: boolean;
}) {
  const ffContext = useContext(FormFieldContext);
  const form = useAppSelector(selectForm);
  const starred = group.selectionStatus === FieldValueGroupSelectionStatus.Selected;
  const iconProps: SvgIconProps = {
    sx: {
      height: 16,
      width: 16,
      color: starred ? goldStar : undefined,
      opacity: starred ? 1 : 0.4,
      cursor: !readonly ? "pointer" : undefined,
      ":hover": !readonly
        ? {
            opacity: 1,
          }
        : undefined,
      ...sx,
    },
    onClick: !readonly
      ? () => {
          if (form !== undefined) {
            ffContext.selectValueGroups(
              [group.id],
              starred ? FieldValueGroupSelectionStatus.Default : FieldValueGroupSelectionStatus.Selected
            );
          }
        }
      : undefined,
  };

  return (
    <Box sx={{ display: "flex", alignItems: "center" }}>
      {starred ? <Star {...iconProps} /> : <StarOutline {...iconProps} />}
    </Box>
  );
}
